export default __webpack_public_path__ + "static/media/testScheduled.13348811.svg";